import React, { useState, lazy } from 'react';
import { ArrowUpRight, X } from 'lucide-react';
interface TeamMemberProps {
  name: string;
  title: string;
  bio: string;
  image: string;
  imageStyle?: React.CSSProperties;
}
export function ExpandableTeamCard({
  name,
  title,
  bio,
  image,
  imageStyle
}: TeamMemberProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  return <div className="relative" data-id="element-58">
      {/* Base Card */}
      <div className="bg-gray-900/50 p-4 sm:p-6 rounded-2xl border border-gray-800/50 text-white transition-all duration-300 hover:shadow-[0_0_15px_5px_rgba(137,207,240,0.3)] hover:-translate-y-1" data-id="element-59">
        <div className="flex flex-col" data-id="element-60">
          <div className="aspect-[4/5] mb-4" data-id="element-61">
            <img src={image} alt={name} className="w-full h-full object-cover object-center rounded-xl" style={imageStyle} loading="lazy" data-id="element-62" />
          </div>
          <div className="flex justify-between items-start" data-id="element-63">
            <div data-id="element-64">
              <h3 className="text-xl sm:text-2xl font-light mb-1 sm:mb-2 tracking-normal" data-id="element-65">
                {name}
              </h3>
              <p className="text-xs sm:text-sm text-gray-400 font-light" data-id="element-66">
                {title}
              </p>
            </div>
            <button onClick={() => setIsExpanded(true)} className="p-1.5 sm:p-2 hover:bg-white/10 rounded-full transition-colors" aria-label="Expand bio" data-id="element-67">
              <ArrowUpRight className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-68" />
            </button>
          </div>
        </div>
      </div>
      {/* Expanded View */}
      {isExpanded && <>
          <div className="fixed inset-0 bg-black/80 z-40" onClick={() => setIsExpanded(false)} data-id="element-69" />
          <div className="fixed inset-4 z-50 flex items-center justify-center" data-id="element-70">
            <div className="bg-gray-900 w-full max-w-3xl max-h-[calc(100vh-2rem)] rounded-2xl border border-gray-800 text-white overflow-hidden shadow-[0_0_25px_8px_rgba(137,207,240,0.25)]" data-id="element-71">
              <div className="flex justify-between items-start p-4 sm:p-6 border-b border-gray-800 sticky top-0 bg-gray-900" data-id="element-72">
                <div data-id="element-73">
                  <h2 className="text-xl sm:text-2xl font-light mb-1 tracking-normal" data-id="element-74">
                    {name}
                  </h2>
                  <p className="text-sm text-gray-400 font-light" data-id="element-75">{title}</p>
                </div>
                <button onClick={() => setIsExpanded(false)} className="p-1.5 hover:bg-white/10 rounded-full transition-colors flex-shrink-0" aria-label="Close bio" data-id="element-76">
                  <X className="w-5 h-5" data-id="element-77" />
                </button>
              </div>
              <div className="p-4 sm:p-6 overflow-y-auto max-h-[calc(100vh-10rem)]" data-id="element-78">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-79">
                  <div className="aspect-[4/5] w-full" data-id="element-80">
                    <img src={image} alt={name} className="w-full h-full object-cover object-center rounded-xl" style={imageStyle} loading="lazy" data-id="element-81" />
                  </div>
                  <div className="overflow-y-auto" data-id="element-82">
                    <p className="text-sm sm:text-base text-gray-300 leading-relaxed font-light" data-id="element-83">
                      {bio}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>}
    </div>;
}
export default {
  ExpandableTeamCard
};